import { atom, useAtom,SetStateAction } from 'jotai';

// @ts-ignore
type TUseDimReturn = [boolean, SetAtom<[SetStateAction<string>], void>];

export const dimAtom = atom<boolean>(false);

const useDim = (params?: boolean): TUseDimReturn => {
  const [isUseDim, setIsUseDim] = useAtom(dimAtom);
  if (params) setIsUseDim(params);
  return [isUseDim, setIsUseDim];
};

export default useDim;
